import z from 'zod';

export const deleteNote = (id: number) => {
  return {
    endpoint: `/notes/${id}`,
    method: 'DELETE',
    responseSchema: z.unknown(),
  } as const;
};
